import { DocumentRequirementAttribute } from '../../driver/models/document/document-requirement-attribute.model';

export class AuthorizedPresence {
    public id: number;
    public customerNumberId: number;
    public authorizedPresenceTypeId: number;
    public insClassTypeId: number;
    public authorizedPresenceProofDocumentRequirementId: number;
    public authorizedPresenceSecondaryProofDocumentRequirementId: number;
    public authorizedPresenceProofDocumentTypeId: number;
    public authorizedPresenceSecondaryProofDocumentTypeId: number;
    public residencyTypeId: number;
    public useDocumentIssueDate: boolean;
    public authorizedPresenceDurationValue: number;
    public authorizedPresenceDurationTypeId: number;
    public proofDocumentRequirementAttributes: DocumentRequirementAttribute[];
    public secondaryProofDocumentRequirementAttributes: DocumentRequirementAttribute[];
    public updatedBy: string;
    public updatedDate: Date;
    public insClassOtherType: string;
}
